/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState, useEffect} from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
// material
import ExpandableSection from "../../../../../material/expandablesection/expandablesection";
import { Document, Page, pdfjs } from 'react-pdf';
import { Button } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './invoice_styles';
import {cacheInvoiceBase64} from "../../../../../state/slices/account";

/* ========== ~~~~~~~~~~ INVOICE PREVIEW ~~~~~~~~~~ ========== */
const InvoicePreview = injectSheet(styles)((props) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const dispatch = useDispatch()
  const uuid = props.uuid
  const invoiceNo = props.invoiceNo

  const invoiceData = useSelector((state) => state.account[uuid])
  const invoiceShown = useSelector((state) => state.account.invoiceShown)
  const [numPages, setNumPages] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [renderedPageNumber, setRenderedPageNumber] = useState(null)
  const isLoading = renderedPageNumber !== pageNumber;

  const invoiceBlob = invoiceData?.blob
  const pdfBase64 = invoiceData?.pdfBase64
  const isOpened = invoiceShown === uuid || false

  const handleDocumentLoad = ({numPages}) => {
    setNumPages(numPages)
  }

  useEffect(() => {
    if (!invoiceBlob) return
    const blob = new Blob([invoiceBlob], {type: "application/pdf"})
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const pdfBase64 = reader.result.split(',')[1]
      dispatch(cacheInvoiceBase64({ uuid, pdfBase64 }))
    }
  }, [invoiceBlob])

  return (
    <div className={props.classes.invoicePreview}>
      <ExpandableSection
        className="expandablePdf"
        isOpened={isOpened}
      >
        <div className="topPanel">
          View - {invoiceNo}
          <div className="buttonsTop">
            <Button text={'Download'}
                    icon={'download'}
                    variant={'none'}
                    klass={'btnDownload'}
                    handleClick={props.handleDownload}/>
            <Button text={'Close'}
                    klass={'btnClose'}
                    handleClick={props.handleClose}/>
          </div>
        </div>
        <Document className="image" file={`data:application/pdf;base64,${pdfBase64}`} onLoadSuccess={handleDocumentLoad}>
          {isLoading && renderedPageNumber ? (
            <Page
              key={renderedPageNumber}
              className="prevPage"
              pageNumber={renderedPageNumber}
            />
          ) : null}
          <Page key={pageNumber}
                pageNumber={pageNumber}
                onRenderSuccess={() => setRenderedPageNumber(pageNumber)}
          />
          <div className="page-controls">
            <button
              disabled={pageNumber <= 1}
              onClick={() => setPageNumber(pageNumber - 1)}
              type="button"
              aria-label="Previous page"
            >
              ‹
            </button>
            <span>
            {pageNumber}
              {' '}
              of
              {' '}
              {numPages}
          </span>
            <button
              disabled={pageNumber >= numPages}
              onClick={() => setPageNumber(pageNumber + 1)}
              type="button"
              aria-label="Next page"
            >
              ›
            </button>
          </div>
        </Document>
        <div className="buttonsBtm">
          <Button text={'Download'}
                  icon={'download'}
                  variant={'none'}
                  klass={'btnDownload'}
                  handleClick={props.handleDownload}/>
          <Button text={'Close'}
                  klass={'btnClose'}
                  handleClick={props.handleClose}/>
        </div>
      </ExpandableSection>
    </div>
  )
})

export default InvoicePreview;